import { useEffect } from 'react'
import { Route, Location } from 'react-router'
import { PatchedTelemetryRoutes } from '@workwhile/telemetry/react'
import { useLocation } from 'react-router-dom'
import { ModalPagePanel, PageContainer } from './layout/PageContainer'
import { ShiftDetail } from './ShiftDetailPage'
import { ShiftEditorPage } from './ShiftEditorPage'
import { WorkerProfilePage } from './WorkerProfilePage'
import { ListDetailPage } from './ListDetailPage'
import { InvoiceDetailPage } from './InvoiceDetailPage'
import { UpcomingInvoiceDetailPage } from './UpcomingInvoiceDetailPage'
import { WorkerShiftsPage } from './WorkerShiftsPage'

const routes = (
  <>
    <Route path={'/shift/:shiftId'} element={<ShiftDetail />} />
    <Route
      path={'/company/:companyId/shift/:shiftId'}
      element={<ShiftDetail />}
    />
    <Route
      path={'/home/shift-editor/:shiftId/*'}
      element={<ShiftEditorPage />}
    />
    <Route path={'/workers/:workerId'} element={<WorkerProfilePage />} />
    <Route path={'/workers/list/:rosterId'} element={<ListDetailPage />} />
    <Route path={'/workers/:workerId/shifts'} element={<WorkerShiftsPage />} />
    <Route
      path={'/payments/invoice/:invoiceId'}
      element={<InvoiceDetailPage />}
    />
    <Route
      path={'/payments/upcoming-invoice'}
      element={<UpcomingInvoiceDetailPage />}
    />
  </>
)

const ModalContent = ({
  location,
  zIndex,
}: {
  location: Location
  zIndex: number
}) => (
  <ModalPagePanel style={{ zIndex }}>
    <PageContainer $inModal={true}>
      <PatchedTelemetryRoutes location={location}>
        {routes}
      </PatchedTelemetryRoutes>
    </PageContainer>
  </ModalPagePanel>
)

export function ModalRoutes() {
  const location = useLocation()
  const backgroundStack =
    (location.state && location.state.backgroundStack) || []
  // Below the AppShell's navbar and top bar (100), so the phone menu opens over modals
  const baseModalZIndex = 10

  // Only mounted while a modal is open, so unlock on unmount
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  // Function to recursively render modals (while maintaining the context of the background modal)
  const renderForegroundModal = (index: number) => {
    if (index > backgroundStack.length) {
      return null
    }
    const modalLocation = backgroundStack[index] || location
    return (
      <>
        {renderForegroundModal(index + 1)}
        <ModalContent
          location={modalLocation}
          zIndex={baseModalZIndex + index}
        />
      </>
    )
  }
  return renderForegroundModal(1)
}
